
import { useRef } from 'react';
import { useNavigate } from "react-router-dom"
import { Table,Input,Button,Empty,Space } from 'antd';
import { DataType, column } from './column';
import { channelList } from '@/services/channel';
import useSearchTable from '@/hooks/useList';
import ChannelContent from './components/channelContent';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';

export default function ClaimsPage() {
    const nav = useNavigate();
    const { menuId } = useGetCurMenuId();
    const dialog = useRef<any>(null);
    const defaultValue = {
      Name: '',
    }
    const {
      data,
      total,
      loading,
      fetchData,
      searchParams,
      handleSearch,
      handlePageChange
    } = useSearchTable(channelList, defaultValue );
    
    const search = (e:any)=>{
      handleSearch({Name: e.target.value})
    }
  return (
    <>
      <div className="headerTitle">
        <div>
          <h2>渠道管理</h2>
        </div>
        
      </div>

      <div className="card">
        <div className="searchCond" style={{ width:'55%' }}>
          <Space size='middle'>
            <Input allowClear placeholder="渠道名称" onPressEnter={search} size='large' onChange={search}/>
            
              <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
            
            <Button type="primary" size='large' onClick={()=>{ nav('/main/supplyProducts') }}>权益活动管理</Button>
            <MenuPermissionControl menuId={menuId} operation="edit" >
              <Button type="primary" size='large' onClick={()=>{
                dialog.current?.open('add');
              }}>新增渠道</Button>
            </MenuPermissionControl>
          </Space>
        </div>

        <div className="overflow-x-auto">
          <Table<DataType> rowKey='id'
          columns={[
            ...column,
            {
              title: '操作',
              key: 'action',
              render: (_, record) => (
                <Space size="middle">
                  <MenuPermissionControl menuId={menuId} operation="edit" >
                    <Button onClick={()=>{ dialog.current?.open('edit',record) }}>编辑</Button>
                  </MenuPermissionControl>
                </Space>
              ),  
            }
          ]} 
          dataSource={data as DataType[]}
          loading={loading}
          pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
          scroll={{ x: 'max-content', y: 580 }}
          locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
          />
        </div>
      </div>
      <ChannelContent ref={dialog} save={handleSearch}/>
    </>
  );
} 